module.exports = __webpack_public_path__ + "static/media/insurance-02.4aa0bc80.png";